import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment, { now } from 'moment'
import { DatePicker, Button, Tabs, Table, Tooltip, Spin, Icon, Row, Col, Input, Form } from 'antd';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import SearchAlumniFilter from '../Inc/SearchAlumniFilter';
import { history } from '../../container/History';
import InputMask from 'react-input-mask'
import NESAFooter from '../Inc/NESAFooter';
import CustomPopupModal from '../Inc/customPopupModal';
import './style.css';


const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const TabPane = Tabs.TabPane;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

let currentYear = `${moment().year()}-01-01`;
currentYear = moment(currentYear).format('MM-DD-YYYY');
let nextYear = moment(currentYear).add(1, 'Year').format('MM-DD-YYYY');
let Q2 = moment(currentYear).add(3, 'month').format('MM-DD-YYYY');
let Q3 = moment(currentYear).add(6, 'month').format('MM-DD-YYYY');
let Q4 = moment(currentYear).add(9, 'month').format('MM-DD-YYYY');
// let Q4 = moment(currentYear).add(12, 'month').format('MM-DD-YYYY');
let today = moment().format('YYYY-MM-DD')

class AdminDashboard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      // ...props,
      columns: ['firstname', 'lastname', 'email', 'companyname', 'home_state', 'home_zip5'],
      thisyear: moment().format('YYYY'),
      aboutToExpirePopup: {
        expireDate: undefined,
        doesShow: false,
        role: ''
      }
    }
    this.columns = [{
      title: 'List Name',
      dataIndex: 'PreferenceName',
      key: 'PreferenceName',
    }, {
      title: 'Last Modified',
      dataIndex: 'LastModified',
      key: 'LastModified',
    }, {
      title: 'Date Last Run',
      dataIndex: 'LastExecutionDate',
      key: 'LastExecutionDate',
    },
    {
      title: 'Run',
      dataIndex: 'Run',
      key: 'Run',
      render: (text, record) => (
        <span>
          <span className='run-preference' onClick={() => history.push("/list-and-search/" + record.PreferenceName + "/" + record.ListType + "/admin")} > <i className="fa fa-upload"></i> Run</span>
        </span>
      )
    }]

  }


  componentDidMount = () => {
    

    console.log("currentYear " + currentYear);
    console.log("today " + today);
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    this.props.actions.getProfileInfo(personGUID)
    this.props.actions.getAlumniEagleInfo(personGUID)
    this.props.actions.getdashboardmylist()
    this.props.actions.getdashboardquicklist()
    this.props.actions.getalumnisummary()
    this.props.actions.getEagleScoutsSummary(currentYear, today)
    this.props.actions.getNESASummary(currentYear, today)
  }

  componentWillReceiveProps = (nextprops) => {
    if(this.props.aboutToExpirePopup !== nextprops.aboutToExpirePopup && nextprops.aboutToExpirePopup.doesShow){
      this.setState({
        aboutToExpirePopup: nextprops.aboutToExpirePopup
      })
    }
  }
  // address = () => {
  //   if (!this.props.profileinfo) {
  //     return <Skeleton width={100} />
  //   } else {
  //     let personaddress = this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary == "True"))[0]
  //     if (personaddress) return (<span> <i class='fa fa-map-marker'></i> {personaddress.city + " " + personaddress.state + " " + personaddress.zipCode} </span>)
  //   }
  // }

  email = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    } else {
      let personemail = this.props.profileinfo.emails.filter((data) => data.isPrimary == "True")[0]
      return (<span> <i class='fa fa-envelope'></i> {personemail ? personemail.email : ""} </span>)
    }
  }

  phone = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    } else {
      let personphone = this.props.profileinfo.phones.filter((data) => data.isPrimary == "True")[0];

      if (personphone) {
        let phoneNumber;
        let countryCode = personphone.countryCode.replace(/^0+/, '');

        if (personphone.country && personphone.country === 'USA') {
          const areaCode = personphone.areaCode ? personphone.areaCode : '';
          const prefix = personphone.prefix ? personphone.prefix : '';
          const lineNumber = personphone.lineNumber ? personphone.lineNumber : '';
          phoneNumber = `${countryCode} ${areaCode} ${prefix} ${lineNumber}`
        } else if (personphone.country) {
          const truncatedphoneNumber = personphone.fullPhoneNumber.substr(personphone.fullPhoneNumber.indexOf(' ') + 1);
          const trimmedNumber = truncatedphoneNumber.trim().replace(/^0+/, '');
          phoneNumber = `${countryCode} ${trimmedNumber}`
        }

        return (<span> <i class='fa fa-phone'></i> {personphone ? ` +${phoneNumber}` : ""} </span>)
      }
    }
  }

  name = () => {
    if (!this.props.profileinfo)
      return <Skeleton width={300} />
    else {
      const { profile } = this.props.profileinfo || {};
      const { nickName, lastName, nameSuffix, fullName } = profile || {};

      const formattedName = nickName
        ? `${nickName} ${lastName} ${nameSuffix ? nameSuffix : ''}`
        : fullName;
      return formattedName
    }
  }
  checkIsDeceased = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={100} />
    }   
    else{
      const { profile } = this.props.profileinfo || {};
      const { isDeceased } = profile || this.props.profileinfo;

      return isDeceased ? " - Deceased" : '';
    }
  }


  filterColumn = (columnname) => {
    history.push('/quicksearch')
  }

  rendermylist = () => {
    if (this.props.mypreferencelist) {
      let PreferenceNameslist = this.props.mypreferencelist
      return <Table
        ref={el => (this.componentRef = el)}
        dataSource={PreferenceNameslist.PreferenceNames}
        columns={this.columns}
        pagination={false} />
    } else {
      return <div>
        <Spin indicator={LoadingIcon} className="loading-state" tip="Loading My Lists..." />
      </div>
    }
  }

  renderquicklist = () => {
    if (this.props.quickpreferencelist) {
      let PreferenceNameslist = this.props.quickpreferencelist
      return <Table
        ref={el => (this.componentRef = el)}
        dataSource={PreferenceNameslist.PreferenceNames}
        columns={this.columns}
        pagination={false} />
    } else {
      return <div>
        <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Quick Lists..." />
      </div>
    }
  }


  renderProfileImg = () => {
    if (!this.props.profileinfo || this.props.pic_updating) {
      return <Spin indicator={LoadingIcon} style={{ width: '99px' }} className='ad-profile-img flex-center' />
    }
    else {
      let profile = this.props.profileinfo
      let imgurl = profile && profile.profile &&  profile.profile.pictureUrl ? profile.profile.pictureUrl : profile && profile.pictureUrl ? profile.pictureUrl : '';
      if (imgurl == "" || imgurl == null) imgurl = "../profileimage.png"
      return <img src={imgurl} className='ad-profile-img' />
    }
  }

  getTotalAlumniCount = () => {
    if (!this.props.alumnisummary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.alumnisummary.alumniCountTotal.toLocaleString()}</span>
    }
  }

  getAlumniCountYear = () => {
    if (!this.props.alumnisummary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.alumnisummary.alumniCountYear.toLocaleString()}</span>
    }
  }

  getTotalNesaCount = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.NESACountTotal.toLocaleString()}</span>
    }
  }
  
  getCurrentYearConverstionRate = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' style={{display: "inline-block",fontSize: '20px'}}/>
    }
    else {
      return <span className='dashboard-heading' style={{display: "inline-block",fontSize: '20px'}}> {this.props.eagleScouts_Summary.eagleConversionRateCurrentYear}%</span>
    }
  }
  getConverstionRateQ1 = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.eagleConversionRateCurrentYearQ1}%</span>
    }
  }
  getConverstionRateQ2 = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.eagleConversionRateCurrentYearQ2}%</span>
    }
  }
  getConverstionRateQ3 = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.eagleConversionRateCurrentYearQ3}%</span>
    }
  }
  getConverstionRateQ4 = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.eagleConversionRateCurrentYearQ4}%</span>
    }
  }

  getbtwcount = () => {
    if (this.props.summarybtwloading) {
      return <Spin indicator={LoadingIcon} />
    }
    else if (this.props.alumnisummarybtw) {
      return <span className='dashboard-heading' id='alumni-member-result'> {this.props.alumnisummarybtw.alumniCountDateRange.toLocaleString()}</span>
    }
    else {
      return ""
    }
  }

  renderAlumniDateRange = () => {
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (<Form onSubmit={this.onChange} className="active-member" style={{ padding: 0 }}>
      <Col xs={24} sm={24} md={9} lg={9} xl={9}>
        <FormItem
          label="From"
          hasFeedback
        >
          {getFieldDecorator('Alumni_StartYearDate', {
            initialValue: '',
            rules: [
              { required: true, message: 'Enter "From" date!' },
              {
                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                message: `Please enter correct format MM/DD/YYYY Pattern`
              }
            ],
          })(
            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
            <InputMask
              mask="99/99/9999"
              placeholder='MM/DD/YYYY'
              style={{ borderRadius: 5 }}
              alwaysShowMask
              maskChar={null}
              className="ant-input"
              render={(ref, props) => (
                <Input />
              )}
            />
          )}
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={9} lg={9} xl={9}>
        <FormItem
          label="To"
          hasFeedback
        >
          {getFieldDecorator('Alumni_EndYearDate', {
            initialValue: '',
            rules: [
              { required: true, message: 'Enter "To" date!' },
              {
                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                message: `Please enter correct format MM/DD/YYYY Pattern`
              }
            ],
          })(
            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
            <InputMask
              mask="99/99/9999"
              placeholder='MM/DD/YYYY'
              style={{ borderRadius: 5 }}
              alwaysShowMask
              maskChar={null}
              className="ant-input"
              render={(ref, props) => (
                <Input />
              )}
            />
          )}
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
        <FormItem> <Button type="primary" id='alumni-active-member-button' className='active-member-button' htmlType='submit' style={{ margin: "30px 0 0", float: 'unset', width: "100%", padding: "8px 0px", height: 'auto' }}>
          {
            // this.props.summarybtwloading && !this.props.alumnisummarybtw ? "SEARCHING" :
            "SEARCH"}</Button> </FormItem>
      </Col>

    </Form>)
  }

  // For EagleScouts

  getTotalEagleScoutsCount = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.eagleCountTotal.toLocaleString()}</span>
    }
  }

  getYearEagleScoutsCount = () => {
    if (!this.props.eagleScouts_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.eagleScouts_Summary.eagleInCurrentYear.toLocaleString()}</span>
    }
  }

  getEagleScoutsDateRangecount = () => {
    if (this.props.eagleScoutsCustomDate_SummaryLoading) {
      return <Spin indicator={LoadingIcon} />
    }
    else if (this.props.eagleScoutsCustomDate_Summary) {
      return <span className='dashboard-heading' id='eagle-scout-member-result'> {this.props.eagleScoutsCustomDate_Summary.eagleCountDateRange.toLocaleString()}</span>
    }
    else {
      return ""
    }
  }

  renderEagleScoutsDateRange = () => {
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (<Form onSubmit={this.onChangeEagleScouts} className="active-member" style={{ padding: 0 }}>
      <Col xs={24} sm={24} md={9} lg={9} xl={9}>
        <FormItem
          label="From"
          hasFeedback
        >
          {getFieldDecorator('EagleScouts_StartYearDate', {
            initialValue: '',
            rules: [
              { required: true, message: 'Enter "From" date!' },
              {
                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                message: `Please enter correct format MM/DD/YYYY Pattern`
              }
            ],
          })(
            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
            <InputMask
              mask="99/99/9999"
              placeholder='MM/DD/YYYY'
              style={{ borderRadius: 5 }}
              alwaysShowMask
              maskChar={null}
              className="ant-input"
              render={(ref, props) => (
                <Input />
              )}
            />
          )}
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={9} lg={9} xl={9}>
        <FormItem
          label="To"
          hasFeedback
        >
          {getFieldDecorator('EagleScouts_EndYearDate', {
            initialValue: '',
            rules: [
              { required: true, message: 'Enter "To" date!' },
              {
                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                message: `Please enter correct format MM/DD/YYYY Pattern`
              }
            ],
          })(
            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
            <InputMask
              mask="99/99/9999"
              placeholder='MM/DD/YYYY'
              style={{ borderRadius: 5 }}
              alwaysShowMask
              maskChar={null}
              className="ant-input"
              render={(ref, props) => (
                <Input />
              )}
            />
          )}
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
        <FormItem> <Button type="primary" id='eaglescout-active-member-button' className='active-member-button' htmlType='submit' style={{ margin: "30px 0 0", float: 'unset', width: "100%", padding: "8px 0px", height: 'auto' }}>
          {
            // this.props.eagleScoutsCustomDate_SummaryLoading && !this.props.eagleScoutsCustomDate_Summary ? "SEARCHING" :
            "SEARCH"}</Button> </FormItem>
      </Col>

    </Form>)
  }

  // For NESA 

  getTotalNESACount = () => {
    if (!this.props.nesa_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.nesa_Summary.NESACountTotal.toLocaleString()}</span>
    }
  }

  getYearNESACount = () => {
    if (!this.props.nesa_Summary) {
      return <Spin indicator={LoadingIcon} className='flex-center' />
    }
    else {
      return <span className='dashboard-heading'> {this.props.nesa_Summary.NESACountYear.toLocaleString()}</span>
    }
  }

  getNESADateRangecount = () => {
    if (this.props.nesaCustomDate_SummaryLoading) {
      return <Spin indicator={LoadingIcon} />
    }
    else if (this.props.nesaCustomDate_Summary) {
      return <span className='dashboard-heading' id='nesa-member-result'> {this.props.nesaCustomDate_Summary.NESACountDateRange.toLocaleString()}</span>
    }
    else {
      return ""
    }
  }


  renderNESADateRange = () => {
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (<Form onSubmit={this.onChangeNESA} className="active-member" style={{ padding: 0 }}>
      <Col xs={24} sm={24} md={9} lg={9} xl={9}>
        <FormItem
          label="From"
          hasFeedback
        >
          {getFieldDecorator('NESA_StartYearDate', {
            initialValue: '',
            rules: [
              { required: true, message: 'Enter "From" date!' },
              {
                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                message: `Please enter correct format MM/DD/YYYY Pattern`
              }
            ],
          })(
            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
            <InputMask
              mask="99/99/9999"
              placeholder='MM/DD/YYYY'
              style={{ borderRadius: 5 }}
              alwaysShowMask
              maskChar={null}
              className="ant-input"
              render={(ref, props) => (
                <Input />
              )}
            />
          )}
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={9} lg={9} xl={9}>
        <FormItem
          label="To"
          hasFeedback
        >
          {getFieldDecorator('NESA_EndYearDate', {
            initialValue: '',
            rules: [
              { required: true, message: 'Enter "To" date!' },
              {
                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                message: `Please enter correct format MM/DD/YYYY Pattern`
              }
            ],
          })(
            // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
            <InputMask
              mask="99/99/9999"
              placeholder='MM/DD/YYYY'
              style={{ borderRadius: 5 }}
              alwaysShowMask
              maskChar={null}
              className="ant-input"
              render={(ref, props) => (
                <Input />
              )}
            />
          )}
        </FormItem>
      </Col>
      <Col xs={24} sm={24} md={5} lg={5} xl={5}>
        <FormItem> <Button type="primary" id='nesa-active-member-button' className='active-member-button' htmlType='submit' style={{ margin: "30px 0 0", float: 'unset', width: "100%", padding: "8px 0px", height: 'auto' }}>
          {
            // this.props.nesaCustomDate_SummaryLoading && !this.props.nesaCustomDate_Summary ? "SEARCHING" :
            "SEARCH"}</Button> </FormItem>
      </Col>

    </Form>)
  }

  onChange = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll(['Alumni_StartYearDate', 'Alumni_EndYearDate'], (err, values) => {
      if (!err) {
        let startdate = moment(values.Alumni_StartYearDate).format('YYYY-MM-DD')
        let enddate = moment(values.Alumni_EndYearDate).format('YYYY-MM-DD')
        this.props.actions.getalumnisummarybtw(startdate, enddate)
      }
    })
    // let startdate = moment(dates[0]).format('YYYY-MM-DD')
    // let enddate = moment(dates[1]).format('YYYY-MM-DD')
    // this.props.actions.getalumnisummarybtw(startdate, enddate)
    // console.log('From: ', dates[0], ', to: ', dates[1]);
    // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
  }


  onChangeEagleScouts = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll(['EagleScouts_StartYearDate', 'EagleScouts_EndYearDate'], (err, values) => {
      if (!err) {
        let startdate = moment(values.EagleScouts_StartYearDate).format('YYYY-MM-DD')
        let enddate = moment(values.EagleScouts_EndYearDate).format('YYYY-MM-DD')
        this.props.actions.getEagleScoutsSummary(startdate, enddate, true)
      }
    })
    // let startdate = moment(dates[0]).format('YYYY-MM-DD')
    // let enddate = moment(dates[1]).format('YYYY-MM-DD')
    // this.props.actions.getalumnisummarybtw(startdate, enddate)
    // console.log('From: ', dates[0], ', to: ', dates[1]);
    // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
  }

  onChangeNESA = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll(['NESA_StartYearDate', 'NESA_EndYearDate'], (err, values) => {
      if (!err) {
        let startdate = moment(values.NESA_StartYearDate).format('YYYY-MM-DD')
        let enddate = moment(values.NESA_EndYearDate).format('YYYY-MM-DD')
        this.props.actions.getNESASummary(startdate, enddate, true)
      }
    })
    // let startdate = moment(dates[0]).format('YYYY-MM-DD')
    // let enddate = moment(dates[1]).format('YYYY-MM-DD')
    // this.props.actions.getalumnisummarybtw(startdate, enddate)
    // console.log('From: ', dates[0], ', to: ', dates[1]);
    // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
  }

  rendereagleflag = () => {
    if (this.props.eagleinfo) {
      if (Object.keys(this.props.eagleinfo).length != 0) {
        if (this.props.eagleinfo.eagleBoardReviewDate != "") {
          return <img className="eagle-logo" src='./eagle-scout.png' />
        }
      }
    }
  }

  disabledDate = (current) => {
    return current > moment();
  }

  address = () => {
    if (!this.props.profileinfo || this.props.loading) {
      return <Skeleton width={200} />
    } else {
      let city = '', state = '', getAddress = ''
      let address = (this.props.profileinfo && this.props.profileinfo.addresses) || [];
      if (address) {
        let personaddress = address.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        if (personaddress) {
          getAddress = personaddress.countryId == '616' || personaddress.country.toLowerCase() == "usa" ?
            `${personaddress.city}${personaddress.state.length ? `, ${personaddress.state}` : ''}`
            : personaddress.address3 ? personaddress.address3 : ''

          // city = personaddress.city
          // state = personaddress.state
        }
      }
      return (<span> <i class='fa fa-map-marker'></i> {getAddress} </span>)
    }
  }

  render() {

    const currentYearConverstionRate_tooltipContent = <div>
        <div>{`Records = MembershipEndDate >= ${currentYear} AND MembershipStartDate < ${nextYear};`}</div>
        <div>{`currentYearConversionRate = 100 * (currentYearQuarter1 + currentYearQuarter2 + currentYearQuarter3 + currentYearQuarter4) / Records;`}</div>
      </div>;
    const quarter1_tooltipContent = <div>
        {/* <div>{`Records = (Number of Eagle Scouts in Current Year Q1 / Total NESA members in Current Year) * 100`}</div> */}
        <div>{`Records = MembershipEndDate >= ${currentYear} AND MembershipStartDate < ${nextYear};`}</div>
        <div>{`currentYearQuarter1 = BoardOfReviewDT >= ${currentYear} AND BoardOfReviewDT < ${Q2} AND CertifiedDT IS NOT NULL;`}</div>
        <div>{`ConversionRateQ1 = 100 * currentYearQuarter1 / Records;`}</div>
      </div>;
    const quarter2_tooltipContent = <div>
         {/* <div>{`Records = (Number of Eagle Scouts in Current Year Q2 / Total NESA members in Current Year) * 100`}</div> */}
        <div>{`Records = MembershipEndDate >= ${currentYear} AND MembershipStartDate < ${nextYear};`}</div>
        <div>{`currentYearQuarter2 = BoardOfReviewDT >= ${Q2} AND BoardOfReviewDT < ${Q3} AND CertifiedDT IS NOT NULL;`}</div>
        <div>{`ConversionRateQ2 = 100 * currentYearQuarter2 / Records;`}</div>
      </div>;
    const quarter3_tooltipContent = <div>
         {/* <div>{`Records = (Number of Eagle Scouts in Current Year Q3 / Total NESA members in Current Year) * 100`}</div> */}
        <div>{`Records = MembershipEndDate >= ${currentYear} AND MembershipStartDate < ${nextYear};`}</div>
        <div>{`currentYearQuarter3 = BoardOfReviewDT >= ${Q3} AND BoardOfReviewDT < ${Q4} AND CertifiedDT IS NOT NULL;`}</div>
        <div>{`ConversionRateQ3 = 100 * currentYearQuarter3 / Records;`}</div>
      </div>;
    const quarter4_tooltipContent = <div>
         {/* <div>{`Records = (Number of Eagle Scouts in Current Year Q4 / Total NESA members in Current Year) * 100`}</div> */}
        <div>{`Records = MembershipEndDate >= ${currentYear} AND MembershipStartDate < ${nextYear};`}</div>
        <div>{`currentYearQuarter4 = BoardOfReviewDT >= ${Q4} AND BoardOfReviewDT < ${nextYear} AND CertifiedDT IS NOT NULL;`}</div>
        <div>{`ConversionRateQ4 = 100 * currentYearQuarter4 / Records;`}</div>
      </div>;
    

    
    return (
      <div>
        <LayoutHeader />

        <AdminNavigation />

        <div className="widget">
          <div className="">
            <div className=''>
              <div className='dashboard-container'>
                <div className='bg-banner'>
                  <Row type="flex" justify="end" align='top'>
                    <Tooltip placement="top" title="Edit Profile">
                      <Button onClick={() => history.push("/my-profile")} type="primary" className="profile-pic-edit" shape="circle" >
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </Button>
                    </Tooltip>
                  </Row>
                  <Row type="flex" justify="start" align='middle'>
                    <Col md={9} lg={6} xl={5}>
                      <div className='profilepic-container'>
                        {this.renderProfileImg()}
                      </div>
                    </Col>
                    <Col md={13} lg={16} xl={17}>
                      <div style={{ padding: '0px 0px 7px 0px' }}>
                        <span className='text' style={{ display: 'inline' }}>{this.name()}</span>
                        <span className='breadcrums'>{this.checkIsDeceased()}</span>
                      </div>
                      <span className='textdesc'> {this.address()} </span>
                      <span className='textdesc'> {this.email()} </span>
                      <span className='textdesc'> {this.phone()} </span>
                    </Col>
                    <Col md={2} lg={2} xl={2}>
                      <div className='text-right'> {this.rendereagleflag()} </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.props.isSuperAlumniAdmin && (
          <div>
        <div className="widget" style={{ marginTop: '0px', marginBottom: '0px' }}>
          <div style={{ marginTop: '0px', marginBottom: '0px', 'width': '1000px', justifyContent: 'spaceAround', 'display': 'flex' }}>
            {/* ------------Total Members------------ */}
            <Col className='padding-r-10' span={9}>
              <div className="sub-title">
                Total Members
              </div>
            </Col>

            {/* ------------Eagle Scout Conversion Rates------------ */}
            <Col className='padding-r-10' span={15} style={{display:'flex', justifyContent: "space-between", alignItems:'baseline' }}>
              <div className="sub-title">
                Eagle Scout Conversion Rates
              </div>
              <div className="sub-title"> Current Year: <Tooltip
                  overlayClassName="converstionRate-tooltip"
                  autoAdjustOverflow={true}
                  title={currentYearConverstionRate_tooltipContent}
                >
                  <Icon type="info-circle-o" />
                </Tooltip> {this.getCurrentYearConverstionRate()}
              </div>
            </Col>
          </div>
        </div>

        <div className="widget" style={{ marginTop: '0px', marginBottom: '0px' }}>
          <div className="dashboard-container">
            <Row type="flex" justify="space-around">
              <Col className='padding-r-10' span={9}>
                <div className="widget widget-h">
                  <div className='widget-container widget-dashboard widget-h' style={{ display: "flex", alignItems: 'center', padding: "20px 10px" }}>
                    <Row type="flex" justify="space-around" style={{ width: "100%" }}>
                      <Col className='widget-start-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getTotalEagleScoutsCount()}
                          <span className='dashboard-title'>Total Eagle Scouts </span>
                          <span className='dashboard-desc'>From the beginning</span>
                        </div>
                      </Col>
                      <Col className='widget-last-section' span={12}>
                        <div className='dashboard-column'>
                        {this.getTotalNesaCount()}
                          <span className='dashboard-title'>Total NESA members </span>
                          <span className='dashboard-desc'>From the beginning  </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col className='padding-l-10' span={15}>
                <div className="widget widget-h" style={{ height: '100%' }}>
                  <div className='widget-container widget-dashboard' style={{ width: "100%", padding:'10px'}}>
                    {/* <Row type="flex" justify="space-around">
                      <Col className='padding-r-10' span={24}>
                        <div className="widget widget-h">
                          <div className='widget-container widget-dashboard widget-h' style={{ display: "flex", alignItems: 'center', padding: "20px 10px" }}> */}
                            <Row type="flex" justify="space-around" style={{ display: 'flex',alignItems: 'center', height:'100%', width: "100%" }}>
                              <Col className='widget-start-section' span={6}>
                                <div className='dashboard-column'>
                                {this.getConverstionRateQ1()}
                          <span className='dashboard-title'>First Quarter <Tooltip 
                          overlayClassName="custom-tooltip"
                          autoAdjustOverflow = {true}
                            title={quarter1_tooltipContent}
                          >
                            <Icon type="info-circle-o" />
                          </Tooltip></span>
                                </div>
                              </Col>
                              <Col className='widget-start-section' span={6}>
                                <div className='dashboard-column'>
                                {this.getConverstionRateQ2()}
                                  <span className='dashboard-title'>Second Quarter  <Tooltip overlayClassName="custom-tooltip"
                          autoAdjustOverflow = {true}
                            title={quarter2_tooltipContent}
                          >
                            <Icon type="info-circle-o" />
                          </Tooltip></span>
                                </div>
                              </Col>
                              <Col className='widget-start-section' span={6}>
                                <div className='dashboard-column'>
                                {this.getConverstionRateQ3()}
                                  <span className='dashboard-title'>Third Quarter <Tooltip overlayClassName="custom-tooltip"
                          autoAdjustOverflow = {true}
                            title={quarter3_tooltipContent}
                          >
                            <Icon type="info-circle-o" />
                          </Tooltip></span>
                                </div>
                              </Col>
                              <Col className='widget-last-section' span={6}>
                                <div className='dashboard-column'>
                                  {this.getConverstionRateQ4()}
                                  <span className='dashboard-title'>Fourth Quarter  <Tooltip overlayClassName="custom-tooltip"
                            autoAdjustOverflow = {true}
                              placement='topLeft'
                            title={quarter4_tooltipContent}
                          >
                            <Icon type="info-circle-o" />
                          </Tooltip></span>
                                </div>
                              </Col>
                            </Row>
                          {/* </div>
                        </div>
                      </Col>
                    </Row> */}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        

        {/* ------------Registered Alumni------------ */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '1000px' }}>
            <div className="sub-title">
              Registered Alumni
            </div>
          </div>
        </div>
        <div className="widget" style={{ marginTop: '0px', marginBottom: '0px' }}>
          <div className="dashboard-container">
            <Row type="flex" justify="space-around">
              <Col className='padding-r-10' span={9}>
                <div className="widget widget-h">
                  <div className='widget-container widget-dashboard widget-h' style={{ display: "flex", alignItems: 'center', padding: "20px 10px" }}>
                    <Row type="flex" justify="space-around" style={{ width: "100%" }}>
                      <Col className='widget-start-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getTotalAlumniCount()}
                          <span className='dashboard-title'>Total Active Members </span>
                          <span className='dashboard-desc'>From the beginning </span>
                        </div>
                      </Col>
                      <Col className='widget-last-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getAlumniCountYear()}
                          <span className='dashboard-title'>Current Year New Members </span>
                          <span className='dashboard-desc'>From JAN {this.state.thisyear}  </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col className='padding-l-10' span={15}>
                <div className="widget widget-h" style={{ height: 'auto' }}>
                  <div className='widget-container widget-dashboard' style={{ padding: '20px 20px 0px' }}>
                    <Row type="flex" justify="space-around">
                      <Col className='widget-last-section' span={17}>
                        <span className="dash-title">ACTIVE MEMBERS BETWEEN THE DATES</span>
                        <hr />

                        <Row className="" type="flex" align="middle" justify="center">
                          {/* <RangePicker disabledDate={this.disabledDate} size="small" onChange={this.onChange} /> */}
                          {this.renderAlumniDateRange()}
                        </Row>
                      </Col>
                      <Col className='widget-last-section flex-center' span={7}>
                        {this.getbtwcount()}
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* ------------Eagle Scouts------------ */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '1000px' }}>
            <div className="sub-title">
              Eagle Scouts
            </div>
          </div>
        </div>

        <div className="widget" style={{ marginTop: '0px', marginBottom: '0px' }}>
          <div className="dashboard-container">
            <Row type="flex" justify="space-around">
              <Col className='padding-r-10' span={9}>
                <div className="widget widget-h">
                  <div className='widget-container widget-dashboard widget-h' style={{ display: "flex", alignItems: 'center', padding: "20px 10px" }}>
                    <Row type="flex" justify="space-around" style={{ width: "100%" }}>
                      <Col className='widget-start-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getTotalEagleScoutsCount()}
                          <span className='dashboard-title'>Total Active Members </span>
                          <span className='dashboard-desc'>From the beginning </span>
                        </div>
                      </Col>
                      <Col className='widget-last-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getYearEagleScoutsCount()}
                          <span className='dashboard-title'>Current Year New Members </span>
                          <span className='dashboard-desc'>From JAN {this.state.thisyear}  </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col className='padding-l-10' span={15}>
                <div className="widget widget-h" style={{ height: 'auto' }}>
                  <div className='widget-container widget-dashboard' style={{ padding: '20px 20px 0px' }}>
                    <Row type="flex" justify="space-around">
                      <Col className='widget-last-section' span={17}>
                        <span className="dash-title">ACTIVE MEMBERS BETWEEN THE DATES</span>
                        <hr />

                        <Row className="" type="flex" align="middle" justify="center">
                          {/* <RangePicker disabledDate={this.disabledDate} size="small" onChange={this.onChange} /> */}
                          {this.renderEagleScoutsDateRange()}
                        </Row>
                      </Col>
                      <Col className='widget-last-section flex-center' span={7}>
                        {this.getEagleScoutsDateRangecount()}
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* ------------NESA Members------------ */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '1000px' }}>
            <div className="sub-title">
              NESA Members
            </div>
          </div>
        </div>

        <div className="widget" style={{ marginTop: '0px', marginBottom: '0px' }}>
          <div className="dashboard-container">
            <Row type="flex" justify="space-around">
              <Col className='padding-r-10' span={9}>
                <div className="widget widget-h">
                  <div className='widget-container widget-dashboard widget-h' style={{ display: "flex", alignItems: 'center', padding: "20px 10px" }}>
                    <Row type="flex" justify="space-around" style={{ width: "100%" }}>
                      <Col className='widget-start-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getTotalNESACount()}
                          <span className='dashboard-title'>Total Active Members </span>
                          <span className='dashboard-desc'>From the beginning </span>
                        </div>
                      </Col>
                      <Col className='widget-last-section' span={12}>
                        <div className='dashboard-column'>
                          {this.getYearNESACount()}
                          <span className='dashboard-title'>Current Year New Members </span>
                          <span className='dashboard-desc'>From JAN {this.state.thisyear}  </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col className='padding-l-10' span={15}>
                <div className="widget widget-h" style={{ height: 'auto' }}>
                  <div className='widget-container widget-dashboard' style={{ padding: '20px 20px 0px' }}>
                    <Row type="flex" justify="space-around">
                      <Col className='widget-last-section' span={17}>
                        <span className="dash-title">ACTIVE MEMBERS BETWEEN THE DATES</span>
                        <hr />

                        <Row className="" type="flex" align="middle" justify="center">
                          {/* <RangePicker disabledDate={this.disabledDate} size="small" onChange={this.onChange} /> */}
                          {this.renderNESADateRange()}
                        </Row>
                      </Col>
                      <Col className='widget-last-section flex-center' span={7}>
                        {this.getNESADateRangecount()}
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        
        </div>
)}

        <div className='widget dash-list'>
          <div className='dashboard-container dashboard-table'>
            <Tabs>
              <TabPane tab="RECENT LISTS" key="1">
                <div className='create-list'><a onClick={() => history.push('/list-and-search')}><span>Create List <i className="fa fa-plus-circle" aria-hidden="true"></i></span></a></div>
                {this.rendermylist()}
              </TabPane>
              <TabPane tab="QUICK LISTS" key="2">
                <div className='create-list'><a onClick={() => history.push('/list-and-search')}><span>Create List <i className="fa fa-plus-circle" aria-hidden="true"></i></span></a></div>
                {this.renderquicklist()}
              </TabPane>
            </Tabs>
          </div>
        </div>
        {/* <FAQ /> */}
        <NESAFooter />
        
        {(this.state.aboutToExpirePopup && this.state.aboutToExpirePopup.doesShow) && <CustomPopupModal 
            doesShowPopup={this.state.aboutToExpirePopup.doesShow} 
          closePopup={() => this.setState((prev) => ({
            ...prev,
            aboutToExpirePopup: {
              ...prev.aboutToExpirePopup,
              doesShow: false
            }
          }))} 
            popupTitle={""} 
            popupPrimaryContent={<div>Your <span style={{fontWeight: 'bold'}}>{this.state.aboutToExpirePopup.role}</span> role access is set to expire on <span style={{color: 'red'}}>{moment(this.state.aboutToExpirePopup.expireDate).format("MM/DD/YYYY")}</span>.</div>}
            popupSecondaryContent={<div>Please contact your Super Admin to request an extension and avoid any disruption to your access.</div>} 
            />}
      </div>
    );
  }
}



function mapStateToProps(state) {
  return {
    profileinfo: state.profilereducer.profileinfo,
    mypreferencelist: state.dashboardmypreferencelistreducer.mypreferencelist,
    quickpreferencelist: state.dashboardquickpreferencelistreducer.quickpreferencelist,
    summaryloading: state.alumnisummaryreducer.loading,
    alumnisummary: state.alumnisummaryreducer.summary,
    summarybtwloading: state.alumnisummarybtwreducer.loading,
    alumnisummarybtw: state.alumnisummarybtwreducer.summary,

    eagleScouts_Summary: state.eagleScoutsSummaryreducer.summary,
    eagleScouts_SummaryLoading: state.eagleScoutsSummaryreducer.loading,

    eagleScoutsCustomDate_SummaryLoading: state.eagleScoutsSummaryCustomDatereducer.loading,
    eagleScoutsCustomDate_Summary: state.eagleScoutsSummaryCustomDatereducer.summary,

    nesa_Summary: state.nesaSummaryreducer.summary,
    nesa_SummaryLoading: state.nesaSummaryreducer.loading,

    nesaCustomDate_SummaryLoading: state.nesaSummaryCustomDatereducer.loading,
    nesaCustomDate_Summary: state.nesaSummaryCustomDatereducer.summary,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,

    aboutToExpirePopup: state.aboutToExpirePopupReducer.aboutToExpirePopup

  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Form.create()(AdminDashboard));



// WEBPACK FOOTER //
// ./src/components/Dashboard/AdminDashboard.js